import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { AboutPage } from './pages/AboutPage';
import { ContestPage } from './pages/ContestPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { PricingPage } from './pages/PricingPage';
import { DmcaPage } from './pages/DmcaPage';
import { RedditPage } from './pages/RedditPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/" element={<App data-id="element-15" />} data-id="element-14" />
        <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
        <Route path="/contest" element={<ContestPage data-id="element-19" />} data-id="element-18" />
        <Route path="/terms" element={<TermsPage data-id="element-21" />} data-id="element-20" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-23" />} data-id="element-22" />
        <Route path="/pricing" element={<PricingPage data-id="element-25" />} data-id="element-24" />
        <Route path="/dmca" element={<DmcaPage data-id="element-27" />} data-id="element-26" />
        <Route path="/reddit" element={<RedditPage data-id="element-29" />} data-id="element-28" />
      </Routes>
    </BrowserRouter>;
}